import React from 'react'
import styled from 'react-emotion'
import { useQuery } from 'react-apollo-hooks'
import * as Queries from '../queries'
import DestinationCard from './DestinationCard'
import InspirationCard from './InspirationCard'
import { textBuilder } from '../../../resources'
import { ga } from '../../../application'
import getText from '../strings'
import { useAuth } from '../../../authContext'

const Container = styled('div')`
    margin-bottom: 20px;
    margin-top: 20px;
    h2 {
        margin-bottom: 10px;
    }
`

const DestinationCards = styled('div')`
    display: flex;
    margin: 0 -12px 20px -12px;
    justify-content: space-between;    
    @media (max-width: 992px) {
        flex-direction: column;
        >div:first-child {
            margin-bottom: 20px;            
        }    
    }        
`

const InspirationCards = styled('div')`
    display: flex;
    flex-wrap: wrap;
    margin: 0 -12px;    
    @media (max-width: 992px) {        
        >div:first-child {
            margin-bottom: 20px;            
        }    
    }        
`

const Overview = ({ bookings }) => {
    if (!bookings || bookings.length > 0)
        return null

    const { profile } = useAuth()
    const { loading, error, data } = useQuery(Queries.getRecommendations())

    if (loading)
        return null

    if (error || !data || !data.destinationRecommendations)
        return null

    const recommendation = data.destinationRecommendations

    ga.push({
        'eventCategory': 'swirep',
        'eventAction': 'display',
        'eventLabel': `recommendation-destination-[${profile.id}]`,
        'event': 'genericTrackEventNonInteraction'
    })

    const textSection = recommendation.isRepeater ? 'repeater' : 'switcher'
    const destination = recommendation.isRepeater
        ? (recommendation.destinations[0] ? recommendation.destinations[0].name : null)
        : recommendation.previousDestination

    return (
        <Container>
            <h2>{textBuilder(getText(textSection, 'title'), destination)}</h2>
            <p>{textBuilder(getText(textSection, 'info'), destination)}</p>
            <DestinationCards>
                {recommendation.destinations.map(d => (
                    <DestinationCard key={d.id} destination={d} userId={profile.id} />
                ))}
            </DestinationCards>
            {recommendation.articles.length > 0 && <h3>{textBuilder(getText('inspirationTitle'), destination)}</h3>}
            {recommendation.articles.length > 0 && <p>{textBuilder(getText('inspirationInfo'), <b>{destination}</b>)}</p>}
            <InspirationCards>
                {recommendation.articles.map(article => (
                    <InspirationCard key={article.id} article={article} userId={profile.id} />
                ))}
            </InspirationCards>
        </Container>
    )
}

export default Overview